import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { FORGOT_PASSWORD_PATH } from "utils/constants/paths";

const ForgotPassword = Loadable(React.lazy(() => import("./View")));

export const ForgotPasswordRoute: IRouteItem = {
  path: FORGOT_PASSWORD_PATH,
  iconName: "",
  element: React.createElement(ForgotPassword),
  showInDrawer: false,
};
